/**
 * @todo add/update JSDoc tags to document your code
 * (see http://usejsdoc.org/ for information on JSDoc tags),
 * then remove this comment block.
 */

/** Checkbox functional (stateless) component */
import React from 'react';
import PropTypes from 'prop-types';
import { keys } from 'lodash';

// Styles
import './checkbox.scss';

export const LABEL_STYLES = {
    hidden: 'hidden',
    visible: 'visible'
};

/**
 * Checkbox pro-forma template for stateless component
 * @todo - add a proper description of the component
 *
 * @access public
 * @param {string} text string describing the component
 * @returns JSX render of the component
 */
const Checkbox = ({
    uid,
    labelForwardRef,
    inputType,
    isChecked,
    labelText,
    parentClasses,
    labelProps,
    importedClasses,
    isDisabled,
    callback,
    value,
    numberOfStudents,
    isGroupCheckbox,
    isEditGroupCheckBox,
    children
}) => {
    const containerClasses = `checkbox__container ${parentClasses || ''} ${isEditGroupCheckBox ? 'margin-top' : ''}`;
    const inputClasses = `checkbox ${importedClasses}`;
    const labelClasses = `checkbox__label ${inputType === LABEL_STYLES.hidden ? 'checkbox__label--hidden' : ''}`;

    const callbackAction = (e) => {
        if (callback && !isDisabled) {
            callback(e);
        }
    };
    const label = (
        <label ref={labelForwardRef} htmlFor={`check-${uid}`} className={labelClasses} {...labelProps}>
            <span className={`checkbox__inner-label ${isEditGroupCheckBox ? 'checkbox__inner-label--edit-group' : ''}`}>{labelText}</span>
        </label>
    );

    const labelForGroup = (
        <label ref={labelForwardRef} htmlFor={`check-${uid}`} className={labelClasses} {...labelProps}>
            { (labelProps && labelProps.title === 'All groups') ?
                <span className="checkbox__inner-label">{labelText}</span> :
                <span className="checkbox__inner-label">{labelText} ({numberOfStudents})</span>
            }
        </label>
    );

    return (
        <div className={containerClasses}>
            <input
                type="checkbox"
                id={`check-${uid}`}
                data-value={value}
                disabled={isDisabled}
                checked={isChecked}
                className={inputClasses}
                onChange={callbackAction}
                aria-label={labelProps && labelProps.title ? labelProps.title : null}
            />
            { isGroupCheckbox ? labelForGroup : label }
            {children}
        </div>
    );
};

/**
 * Define the default values for the properties being used
 */
Checkbox.defaultProps = {
    inputType: 'visible',
    importedClasses: '',
    isDisabled: false
};

const STYLES_NAMES = keys(LABEL_STYLES);
/**
 * Define the type of properties that can be set on this component
 */
Checkbox.propTypes = {
    uid: PropTypes.string.isRequired,
    inputType: PropTypes.oneOf(STYLES_NAMES),
    isChecked: PropTypes.bool,
    labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    parentClasses: PropTypes.string,
    labelProps: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    numberOfStudents: PropTypes.number,
    isGroupCheckbox: PropTypes.bool,
    isEditGroupCheckBox: PropTypes.bool,
    importedClasses: PropTypes.string,
    isDisabled: PropTypes.bool,
    callback: PropTypes.func,
    labelForwardRef: PropTypes.any,
    value: PropTypes.any, // value to use when a callback is used
    children: PropTypes.any
};

export default Checkbox;



// WEBPACK FOOTER //
// ./components/checkbox/checkbox.js